export { Symbol as symbol } from './control/symbol';
export { symbolsFetcher } from './control/fetcher';
//@ts-expect-error
export { pathMap } from '../gen/googleMapsPathMap';
